import React, { useState } from 'react';
import TagsChips from '../generic/tags-chips';

interface TagsChipsFieldProps {
  fieldKey: string;
  label: string;
  tags: string[];
  onChange: (updatedArray: string[], fieldKey: string) => void;
  disabled?: boolean;
}

/**
 * Adapter that bridges TagsChips (which manages its own tagInput state internally)
 * to the standard onChange(updatedArray, fieldKey) signature used throughout
 * schedule-and-details form sections.
 */
const TagsChipsField: React.FC<TagsChipsFieldProps> = ({
  fieldKey,
  label,
  tags,
  onChange,
  disabled = false,
}) => {
  const [tagInput, setTagInput] = useState('');

  const handleAddTag = (tag: string) => {
    const updated = [...tags, tag];
    onChange(updated, fieldKey);
    setTagInput('');
  };

  const handleRemoveTag = (tag: string) => {
    const updated = tags.filter((t) => t !== tag);
    onChange(updated, fieldKey);
  };

  return (
    <TagsChips
      tags={tags}
      tagInput={tagInput}
      onTagInputChange={setTagInput}
      onAddTag={handleAddTag}
      onRemoveTag={handleRemoveTag}
      label={label}
      disabled={disabled}
    />
  );
};

export default TagsChipsField;
